import React, { useState } from "react";
import { Row, Col, Button, Modal, ProgressBar } from "react-bootstrap";
import ReactLoading from "react-loading";

const ProcessingModal = (props) => {
  const [Show, setShow] = useState(props.Show);
  return (
    <Modal
      show={Show}
      // onHide={this.props.nextEvent}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Please Wait...</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          fontFamily: "Times New Roman",
        }}
      >
        <Row className="justify-content-around">
          <Col md={6}>
            <ReactLoading
              type={"bars"}
              color={"brown"}
              height={"20%"}
              width={"50%"}
            />
          </Col>
          <Col
            md={6}
            style={{
              backgroundColor: "brown",
              color: "white",
              fontSize: "15px",
            }}
          >
            {props.message}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="w-100 h-100 d-block p-0 m-0">
        <Row className="w-100 h-100  p-0 ">
          <Col md={12} sm={12} xs={12} className="w-100 h-100 d">
            <ProgressBar
              variant="success"
              animated
              now={props.Progress}
              label={`${props.Progress}% uploaded`}
              className="w-100 h-100 "
            />
            
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ProcessingModal;
